import { createAction } from '@reduxjs/toolkit';

export const changeModalStatus = createAction('global/changeModalStatus');
